import { combineReducers } from 'redux'
import userInfo from './login'
import localeInfo from './locale'
import menuIconInfo from './menuicon'

export default combineReducers({
  userInfo,
  localeInfo,
  menuIconInfo
})